import type { ControlEnv, ControlState } from './types';
import { createTransition } from './transition';
import { FLY } from '../core/config';
import { worldToLayout } from '../core/coords';

const RISE_SECONDS = 1.2;

/** Leave a low boat eye without the free-flight ground clamp snapping the camera upwards. */
export function riseToFlight(state: ControlState, env: ControlEnv): ControlState {
  const height = env.groundHeightAt(worldToLayout(state.pose.position)) + FLY.minClearance;
  if (state.pose.position[1] >= height) return state;
  const pose = {
    ...state.pose,
    position: [state.pose.position[0], height, state.pose.position[2]] as const,
  };
  return {
    ...state,
    mode: 'transition',
    transition: { ...createTransition(state.pose, pose), duration: RISE_SECONDS, arcLiftM: 0 },
  };
}
